import { getProductPoints } from "./getProductPoints";
export var hasUserEnoughPoints = function hasUserEnoughPoints(_ref) {
  var code = _ref.code,
    remainingPoints = _ref.remainingPoints,
    shades = _ref.shades;
  var productPoints = getProductPoints({
    code: code,
    shades: shades
  });
  return productPoints !== undefined && typeof remainingPoints === 'number' && remainingPoints >= productPoints;
};
//# sourceMappingURL=hasUserEnoughPoints.js.map